<template>
    <div>
        <div class="bg">
            <div class="companyName">
                <div class="queryCertificate" @click="goQueryCertificate()">查询证书</div>
                <div @click="goPage()">申请注册</div>
                <!-- <div @click="time()">
                    22222
                </div> -->
            </div>
            <div class="codeBg">
                <div class="txt">
                    <div class="title1">{{companyName}}</div>
                    <div class="title2">助力食品质量人高效培训，能力持续提升</div>
                </div>
                <div class="codeBg2">
                    <iframe :src="link" frameborder="0" height="400px" width="300px" sandbox="allow-scripts allow-top-navigation allow-same-origin"></iframe>
                </div> 
               
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                link:this.$route.query.link ? this.$route.query.link  : "",
                companyName:'',
            }
        },
        // created(){
        //     this.companyId = localStorage.getItem('linkConpanyId')
        //     if(this.companyId){
        //         this.getCompanyName(this.companyId)
        //     }else{
        //         this.getCompanyName(-1)
        //     }
        // },
        mounted(){
            document.title=this.$route.meta.title;
            console.log(this.link)
            this.companyId = localStorage.getItem('linkConpanyId')
            if(this.companyId){
                this.getCompanyName(this.companyId)
            }else{
                this.getCompanyName(-1)
            }
        },
        methods:{
            // time() {
            //     let time1 = 1672545600000
            //     let time = new Date(time1)
            //     var year = time.getFullYear()
		    //     var month = time.getMonth()+1
		    //     var day = time.getDate()
            //     let limitLoginTime = year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day)
            //     console.log(limitLoginTime)
            // },
            goPage(){
                this.$router.push({path:'/bindInfo',query:{isLogin:'no'}})
            },
            goQueryCertificate() {
                this.$router.push({path:'/queryCertificate',query:{isLogin:'no'}})
            },
            getCompanyName(id){
                this.$ajax({
                    url:this.$config.baseApi + "/account/company/reception/" + id,
                    method:'get'
                }).then(res=>{
                    if(res.code == 1){
                        this.companyName = res.data.companyName
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
        }
    }
</script>

<style scoped>
    .bg{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../../../assets/images/common/qr_bg.png) no-repeat center;
        background-size: 100%;
    }
    .codeBg{
        height: 5.5rem;
        width:4.8rem;
        position: absolute;
        top:0;left:0;right:0;bottom: 0;
        margin:auto;
        z-index:10;
        text-align: center;
    }
    .codeBg2{
        height: 4.04rem;
        width:4.8rem;
        background:#fff;
        border-radius: 0.1rem;
    }
    .txt{
        text-align: center;
        font-family:Alibaba PuHuiTi;
        text-shadow:0px 2px 3px rgba(88,150,216,0.98);
    }
    .txt .title1{
        font-size:0.3rem;
        color:#fff;
        font-weight: bold;
    }
    .txt .title2{
        margin:0.05rem 0 0.2rem;
        font-size:0.16rem;
        color:#fff;
    }
    .bg .companyName{
        font-size: 0.2rem;
        color:#fff;
        font-weight:bold;
        margin:0.6rem;
        display:flex;
        justify-content: flex-end;
    }
    .bg .companyName div:nth-child(2){
        cursor: pointer;
    }
    .bg .queryCertificate {
        font-size: .2rem;
        margin-right: .2rem;
        cursor: pointer;
    }
    .companyName .queryCertificate {
        color: #fff;
    }
</style>